// extracted by mini-css-extract-plugin
export default {"group":"XB7MEg4ZY0","left-group":"trl-8L9TMM","leftGroup":"trl-8L9TMM"};